import Icon from '@ant-design/icons';
import { Button, Flex } from 'antd';
import React from 'react';
import NotesIcon from '~/assets/svg/icon-notes.svg?react';
import TrashIcon from '~/assets/svg/icon-trash.svg?react';
import { formatAuthorName, formatDate } from '~/helpers/conversation';

function NoteCard({ note, canDelete, onDelete }) {
  return (
    <div className='note-card self-center max-w-[60%] p-m flex items-center gap-s rounded-md bg-grey-light border border-solid border-grey'>
      <Flex vertical gap={8}>
        <Flex align='center' gap={4}>
          <Icon className='text-grey-dark text-[24px]' component={NotesIcon} />
          <p className='caption2'>Note interne</p>
          <p className='caption1 grow'>
            {formatAuthorName(note.author_first_name, note.author_last_name)}
            {note.is_sav_label && <span> (SAV Label Emmaüs)</span>}
          </p>
        </Flex>
        <p className='body1 break-words' dangerouslySetInnerHTML={{ __html: note.content.replace(/\n/g, '<br />') }} />
        <p className='caption1 text-grey-medium'>{formatDate(note.created_on)}</p>
      </Flex>
      {canDelete && (
        <Button type='text' size='large' className='btn-icon note-delete-btn' onClick={() => onDelete(note.id)}>
          <Icon component={TrashIcon} className='text-[24px] shrink-0' />
        </Button>
      )}
    </div>
  );
}

export default NoteCard;
